import React, { Component } from 'react';
import { connect } from 'react-redux';
import { find, isEmpty } from 'lodash';
import { Spin } from 'antd';

import globalappstate from '../modules/globalappstate';
import uistate from '../modules/uistate';
import common from '../common';
import releasenotes from '../modules/releasenotes';


const { ReleaseNotesStartScreen } = releasenotes;
class StartScreen extends Component {

    label = (key) => {
        return common.getLabel(this.props.labels, "components", 'StartScreen', key);
    }

    render() {
        const appresource = find(this.props.picklists.appResources, { 'appResourceKey': "StartScreen" });
        const loading = isEmpty(appresource);

        return (
            loading ? (
                <div className="loader-content"  >
                    <Spin size="large" />
                </div>
            ) : (
                <div className='homepage' style={{height: this.props.contentHeight, overflowY:'auto'}}>
                    <div className='startscreen' dangerouslySetInnerHTML={{ __html: appresource.value }}>
                    </div>
                    <ReleaseNotesStartScreen />
                </div>
            )
        );
    }
}

function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        contentHeight: state[uistate.constants.NAME].contentheight
    };
}

export default connect(mapStateToProps,
    {

    })(StartScreen);
